// extracted by mini-css-extract-plugin
export default {"button":"fm-z","reviewSort":"gm-z"};